import { Type } from '@angular/core';
import { subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { JepGeoJSONLayer } from '@jeppesen-foreflight/jmkw-types';
import { TwcMixin } from '../../twc.mixin';

// the string in the @subclass defines what value Class.name will return. Only the string past the last '.' is returned. The others are for orgaization and unqiueness.
@subclass('jmkw.layers.TwcGeoJSONLayer')
export class TwcGeoJSONLayer extends TwcMixin<Type<JepGeoJSONLayer>>(
  JepGeoJSONLayer
) {}
